<template>
    <div>
        <div class="ibox-content" data-cy="attendant-department-form-box">
            <h4 class="m-b">{{ __(boxTitle) }}</h4>

            <div class="form-group row m-b-sm">
                <div
                    class="col-md-2"
                    :class="hasError('department_id') ? 'has-error' : ''"
                    v-if="mode != 'application-settings'"
                    data-cy="attendant-department-form-departmentid-selected-div"
                >
                    <label>{{ __("department_symbol") }}*</label>
                    <select-2
                        :readonly="disabled"
                        name="department_id"
                        data-cy="attendant-department-form-departmentid-selected"
                        :settings="{ width: '100%' }"
                        :options="saDepartmentsSelect"
                        v-model="saDepartment"
                        @change="fillDepartmentData()"
                    />
                    <span
                        class="help-block text-danger"
                        v-if="hasError('department_id')"
                        data-cy="attendant-department-form-departmentid-selected-span"
                    >
                        {{ getError("department_id") }}
                    </span>
                </div>
                <div
                    class="col-md-2"
                    :class="
                        mode == 'application-settings' ? 'col-md-4' : 'col-md-2'
                    "
                    data-cy="attendant-department-form-departmentid-name-input-div"
                >
                    <label>{{ __("departments_name") }}</label>
                    <input
                        type="text"
                        class="form-control"
                        data-cy="attendant-department-form-departmentid-name-input"
                        :value="selectedDepartment.department_sa_detail !== null && selectedDepartment.department_sa_detail !== undefined ? selectedDepartment.department_sa_detail.name : ''"
                        disabled
                    />
                </div>

                <div class="col-md-2" data-cy="attendant-department-form-country-selected-div">
                    <label>{{ __("country_or_department_country") }}</label>
                    <select-2
                        :options="countriesSelect2"
                        data-cy="attendant-department-form-departmentid-country-selected"
                        :value="countrySelected"
                        :settings="{ width: '100%' }"
                        disabled
                    />
                </div>
                <div class="col-md-2" data-cy="attendant-department-form-idNumber-type-selected-div">
                    <label>{{ __("identification_number_typ") }}</label>
                    <select-2
                        :settings="{ width: '100%' }"
                        :options="idNumbersSelect2"
                        data-cy="attendant-department-form-idNumber-type-selected"
                        :value="idNumberSelected"
                        disabled
                    />
                </div>

                <div class="col" data-cy="attendant-department-form-idNumber-input-div">
                    <label>{{ __("identification_number") }}</label>
                    <div class="input-group" >
                        <input
                            type="text"
                            class="form-control"
                            data-cy="attendant-department-form-idNumber-input"
                            :value="idNumberDispleyable"
                            disabled
                        />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12 m-b-sm" data-cy="attendant-department-form-adress-one-input-div">
                            <label>{{ __("address") }}</label>
                            <input
                                type="text"
                                data-cy="attendant-department-form-adress-one-input"
                                class="form-control"
                                :value="selectedDepartment.department_sa_detail !== null && selectedDepartment.department_sa_detail !== undefined ? selectedDepartment.department_sa_detail.address : ''"
                                disabled
                            />
                        </div>
                        <div class="col-md-12 m-b-sm" data-cy="attendant-department-form-adress-two-input-div">
                            <input
                                type="text"
                                data-cy="attendant-department-form-adress-two-input"
                                class="form-control"
                                :value="selectedDepartment.department_sa_detail !== null && selectedDepartment.department_sa_detail !== undefined ? selectedDepartment.department_sa_detail.address_2 : ''"
                                disabled
                            />
                        </div>
                        <div class="col-md-6 m-b-sm" data-cy="attendant-department-form-zip-input-div">
                            <label>{{ __("zip") }}</label>
                            <input
                                type="text"
                                class="form-control"
                                data-cy="attendant-department-form-zip-input"
                                :value="selectedDepartment.department_sa_detail !== null && selectedDepartment.department_sa_detail !== undefined ? selectedDepartment.department_sa_detail.zip : ''"
                                disabled
                            />
                        </div>
                        <div class="col-md-6 m-b-sm" data-cy="attendant-department-form-city-input-div">
                            <label>{{ __("city") }}</label>
                            <input
                                type="text"
                                class="form-control"
                                data-cy="attendant-department-form-city-input"
                                :value="selectedDepartment.department_sa_detail !== null && selectedDepartment.department_sa_detail !== undefined ? selectedDepartment.department_sa_detail.city : ''"
                                disabled
                            />
                        </div>
                    </div>
                </div>
                <div
                    class="col-md-6 m-b-sm"
                    v-if="mode == 'application-settings'"
                >
                    <label>{{ __("additional_information") }}</label>
                    <textarea
                        class="form-control"
                        style="height:126px"
                        disabled
                        >{{ selectedDepartment.department_sa_detail !== null && selectedDepartment.department_sa_detail !== undefined ? selectedDepartment.department_sa_detail.remarks : '' }}</textarea
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            saDepartment: null,
            saDepartmentsSelect: [],
            selectedDepartment: {},
            countriesSelect: [],
            foreignTrade: false
        };
    },
    props: {
        saDepartments: {
            type: Array,
            default: () => []
        },
        boxTitle: {
            type: String,
            default: ""
        },
        mode: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        countrySelected() {
            return this.selectedDepartment.department_sa_detail != null
                ? this.selectedDepartment.department_sa_detail.department_country_id != null
                    ? this.selectedDepartment.department_sa_detail.department_country_id
                    : this.selectedDepartment.department_sa_detail.country_id
                : "";
        },
        idNumberSelected() {
            if (this.foreignTrade == false) {
                if(this.selectedDepartment.department_sa_detail !== null && this.selectedDepartment.department_sa_detail !== undefined){
                    return this.selectedDepartment.department_sa_detail.id_number != undefined
                        ? this.selectedDepartment.department_sa_detail.id_number.id
                        : "";
                }
              else{
                  return "";
                }
            } else {
                if(this.selectedDepartment.department_sa_detail !== null  && this.selectedDepartment.department_sa_detail !== undefined) {
                    return this.selectedDepartment.department_sa_detail.secondary_id_number != undefined
                        ? this.selectedDepartment.department_sa_detail.secondary_id_number.id
                        : "";
                }
                else{
                    return "";
                }
            }
        },
        idNumberDispleyable() {
            if (this.foreignTrade == false) {
                if(this.selectedDepartment.department_sa_detail === null  || this.selectedDepartment.department_sa_detail === undefined){
                    return "";
                }
                return this.selectedDepartment.department_sa_detail.identification_number;
            } else {
                if(this.selectedDepartment.department_sa_detail === null  || this.selectedDepartment.department_sa_detail === undefined){
                    return "";
                }
                return this.selectedDepartment.department_sa_detail.secondary_identification_number;
            }
        },
        ...mapGetters({
            countriesSelect2: "getCountriesSelect2",
            idNumbersSelect2: "getIdNumbersTypes",
            currentSaDepartment: "getCurrentSaDepartment",
            errors: "getErrors",
            old: "getOld",
            values: "getValues"
        })
    },
    methods: {
        fillDepartmentData() {
            this.foreignTrade == false;
            this.selectedDepartment = this.saDepartments.find(
                x => x.id == this.saDepartment
            );
            if (this.selectedDepartment == undefined)
                this.selectedDepartment = {};
            else {
                this.$store.commit(
                    "setSelectedSaDepartment",
                    this.selectedDepartment
                );
                this.$emit("change");
            }
        },
        hasError(inputName) {
            return this.errors[inputName] != undefined;
        },
        getError(inputName) {
            return this.errors[inputName][0];
        },
        setIdNumber(country) {
            if (this.countrySelected != "" && this.countrySelected != country) {
                this.foreignTrade = true;
            } else {
                this.foreignTrade = false;
            }
        },
        setData(data) {
            if (
                Object.keys(data).length != 0 &&
                data.department_id != undefined
            ) {
                this.saDepartment = data.department_id;
                this.fillDepartmentData();
            }
        }
    },
    mounted() {
        if (Object.keys(this.currentSaDepartment).length == 0) {
            this.saDepartmentsSelect = this.saDepartments.map(function(item) {
                let department = new Object();
                department.id = item.id;
                department.text = item.name;
                return department;
            });
        } else {
            this.saDepartmentsSelect = this.saDepartments.map(function(item) {
                let department = new Object();
                department.id = item.id;
                department.text = item.name;
                return department;
            });
            this.saDepartment = this.currentSaDepartment.id
        }

        if (Object.keys(this.old).length != 0) {
            this.setData(this.old);
        } else if (Object.keys(this.values).length != 0) {
            this.setData(this.values);
        }
    }
};
</script>

<style lang="scss" scoped></style>
